module.exports = __webpack_public_path__ + "img/@logo_alchera.21ea737d.png";